/** @format */
import showModuleContentApplicationTpl from './showModuleContentApplication.tpl.html';
import 'angular';
import 'angular-translate';
import _ from 'lodash';
import { localeServiceModule } from 'sis-common';
import { applicationDecisionModelModule, commonApplicationDecisionServiceModule, commonEducationServiceModule, commonModuleContentApplicationServiceModule, commonModuleServiceModule, commonPlanServiceModule, commonStudentApplicationServiceModule, commonStudentServiceModule, customStudyDraftSummaryModule, gradeScaleModule, localDateRangeFilterModule, publicPersonServiceModule, recommendationModule } from 'sis-components';
(function () {
  showModuleContentApplicationController.$inject = ["$q", "commonStudentService", "commonCourseUnitService", "defaultPromiseHandler", "$window", "publicPersonService", "commonModuleService", "commonAttainmentService", "commonEducationService", "commonStudentApplicationService", "commonPlanService", "$translate", "localeService", "commonGradeScaleService", "moduleContentApplicationService"];
  angular.module('student.profile.applications.showModuleContentApplication', [commonModuleServiceModule, commonPlanServiceModule, commonStudentServiceModule, publicPersonServiceModule, 'pascalprecht.translate', localeServiceModule, gradeScaleModule, localDateRangeFilterModule, recommendationModule, commonEducationServiceModule, commonStudentApplicationServiceModule, applicationDecisionModelModule, commonApplicationDecisionServiceModule, commonModuleContentApplicationServiceModule, customStudyDraftSummaryModule]).component('showModuleContentApplication', {
    template: showModuleContentApplicationTpl,
    bindings: {
      application: '<',
      readOnly: '<'
    },
    controller: showModuleContentApplicationController
  });

  /**
   * @ngInject
   */
  function showModuleContentApplicationController($q, commonStudentService,
  // NOSONAR
  commonCourseUnitService, defaultPromiseHandler, $window, publicPersonService, commonModuleService, commonAttainmentService, commonEducationService, commonStudentApplicationService, commonPlanService, $translate, localeService, commonGradeScaleService, moduleContentApplicationService) {
    const $ctrl = this;
    $ctrl.$onInit = function () {
      commonStudentService.findStudent($ctrl.application.studentId).then(student => {
        $ctrl.student = student;
      });
      moduleContentApplicationService.loadModuleContentApplicationObjects($ctrl.application).then(result => {
        $ctrl.module = result.module;
        $ctrl.selectedCustomCourseUnitAttainments = result.selectedCustomCourseUnitAttainments;
        $ctrl.selectedCustomModuleAttainments = result.selectedCustomModuleAttainments;
        $ctrl.education = result.education;
        $ctrl.plan = result.plan;
        $ctrl.selectedModules = result.selectedModules;
        $ctrl.selectedModuleAttainmentsByGroupId = result.selectedModuleAttainmentsByGroupId;
        $ctrl.selectedGroupingModules = result.selectedGroupingModules;
        $ctrl.selectedCourseUnits = result.selectedCourseUnits;
        $ctrl.selectedCourseUnitAttainmentsByGroupId = result.selectedCourseUnitAttainmentsByGroupId;
        $ctrl.parentModule = result.parentModule;
        $ctrl.gradeScalesById = result.gradeScalesById;
      }).catch(defaultPromiseHandler.loggingRejectedPromiseHandler);
      $ctrl.customStudyDrafts = _.get($ctrl.application, 'customStudyDrafts');
    };
    $ctrl.isPendingApproval = function () {
      return $ctrl.application.state === 'REQUESTED' || $ctrl.application.state === 'IN_HANDLING';
    };
    $ctrl.isApproved = function () {
      return $ctrl.application.state === 'ACCEPTED' || $ctrl.application.state === 'CONDITIONAL';
    };
    $ctrl.isRejected = function () {
      return $ctrl.application.state === 'REJECTED';
    };
  }
})();